import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../api";

export const doGetAllContacts = createAsyncThunk("contacts/getAllContacts", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.getAllContacts(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUploadContacts = createAsyncThunk("orders/doUploadContacts", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUploadContacts(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateContact = createAsyncThunk("contacts/doCreateContact", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doCreateContact(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateContact = createAsyncThunk("contacts/doUpdateContact", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdateContact(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDeleteContact = createAsyncThunk("contacts/doDeleteContact", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doDeleteContact(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDeleteContacts = createAsyncThunk("contacts/doDeleteContacts", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doDeleteContacts(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});
